var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-6xl m-auto"},[_c('Invoice',{attrs:{"invoice-uuid":_vm.invoiceUuid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }